import { render, staticRenderFns } from "./AttendeeVideos.vue?vue&type=template&id=daac840c&scoped=true&lang=pug"
import script from "./AttendeeVideos.vue?vue&type=script&lang=ts"
export * from "./AttendeeVideos.vue?vue&type=script&lang=ts"
import style0 from "./AttendeeVideos.vue?vue&type=style&index=0&id=daac840c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daac840c",
  null
  
)

export default component.exports